/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import { concat } from 'lodash';
import MapMarkerUser from './modules/mapUser';
import MapMarkerAdmin from './modules/mapAdmin';
import MapDraw from './modules/drawMap';
import auth from '../utils/authen';
import store from '../store';
Vue.use(Router);

export default new Router({
  routes: concat(
    [
      {
        path: '/app',
        name: 'App',
        component: () => import('../App.vue'),
        children: concat(MapDraw, [
          {
            path: '/app/drawMap/*',
            redirect: {
              name: 'drawMap'
            }
          }
        ]),
        beforeEnter(to, from, next) {
          store.dispatch('SET_MODE_VIEW', 'drawable');
          next();
        }
      }
    ],
    [
      {
        path: '/app/user',
        name: 'AppUser',
        component: () => import('../App.vue'),
        children: concat(MapMarkerUser, [
          {
            path: '/app/user/*',
            redirect: {
              name: 'mapMarkerUser'
            }
          }
        ]),
        beforeEnter(to, from, next) {
          let role = auth.get('qlmn_role');
          auth.checkIsAuthenticated().then(valid => {
            if (valid && role) {
              (role !== 'admin')
                ? next()
                : next({
                  name: 'mapMarkerAdmin'
                });
            } else {
              next({
                name: 'login'
              });
            }
          });
        }
      }
    ],
    [
      {
        path: '/app/admin',
        name: 'AppAdmin',
        component: () => import('../App.vue'),
        children: concat(MapMarkerAdmin, [
          {
            path: '/app/admin/*',
            redirect: {
              name: 'mapMarkerAdmin'
            }
          }
        ]),
        beforeEnter(to, from, next) {
          let role = auth.get('qlmn_role');
          auth.checkIsAuthenticated().then(valid => {
            if (valid && role) {
              role === 'admin' ? next() : next({ name: 'mapMarkerUser' });
            } else {
              next({
                name: 'login'
              });
            }
          });
        }
      }
    ],
    [
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login/login.vue'),
        beforeEnter(to, from, next) {
          let role = auth.get('qlmn_role');
          auth.checkIsAuthenticated().then(valid => {
            if (valid && role) {
              (role !== 'admin')
                ? next({
                  name: 'mapMarkerUser'
                })
                : next({
                  name: 'mapMarkerAdmin'
                });
            } else {
              next();
            }
          });
        }
      }
    ],
    [
      {
        path: '*',
        redirect: {
          name: 'login'
        }
      }
    ]
  )
});



// WEBPACK FOOTER //
// ./src/router/index.js